import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20artistic%20illustration%20with%20warm%20golden%20and%20coral%20tones%2C%20abstract%20flowing%20lines%20and%20soft%20gradient%2C%20elegant%20digital%20art%20with%20dreamy%20atmosphere%2C%20clean%20minimal%20composition%2C%20no%20text&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫免费阅读"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-6 backdrop-blur-sm">
          欢迎来到韩漫免费阅读平台
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-3xl">
          韩漫网站免费阅读看漫画
          <br />
          <span className="text-primary-300">下拉双男主</span> 精彩呈现
        </h1>
        <p className="mt-5 text-base md:text-lg text-background-50/80 max-w-2xl leading-relaxed">
          汇集<strong>好看的漫画韩漫免费看</strong>，<strong>韩漫免费无遮漫画</strong>资源一站式畅享。
          随时随地，免费阅读您最喜爱的韩国漫画作品。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/shuang-nanzhu"
            className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始阅读 <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
          <Link
            to="/category/mianfei-wuzhe"
            className="px-8 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/20 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            免费无遮专区
          </Link>
        </div>

        <div className="flex items-center gap-8 mt-10">
          {[
            { num: '2000+', label: '漫画作品' },
            { num: '50万+', label: '活跃读者' },
            { num: '99%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">{stat.num}</p>
              <p className="text-xs md:text-sm text-background-50/70 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}